// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IFieldDropdown } from 'interfaces/back-office/master/field'
import { IFieldGetDropdownAttrs } from 'interfaces/back-office/master/field/field-view.interface'
import { IFieldApiDropdownResponse } from 'interfaces/back-office/master/field/field-api.interface'

// Extensions
import { withHelper_baseResponseDropdownTypesModel } from 'models/extensions/with-helper'
import { withEnvironment } from 'models/extensions/with-environment'

// Base Model
const FieldStoreModel = types
  .model('Field')
  .props({
    masterField_isLoading: types.optional(types.boolean, false),
    masterField_dropdown: withHelper_baseResponseDropdownTypesModel('FieldDropdown'),
  })
  .extend(withEnvironment)
  .actions(self => ({
    masterField_SET_LOADING: (payload: boolean): void => {
      self.masterField_isLoading = payload
    },
    masterField_SET_FIELD_DROPDOWN: (payload: IFieldDropdown[]): void => {
      self.masterField_dropdown = cast(payload.filter(dropdown => dropdown.value))
    },
    masterField_CLEAR_FIELD_DROPDOWN: (): void => {
      self.masterField_dropdown = cast([])
    },
  }))
  .actions(self => ({
    /**
     * @description Fetch field dropdown
     *
     * @param {IFieldGetDropdownAttrs} payload
     *
     * @return {any} any
     */
    masterField_fetchFieldDropdown: flow(function* (payload: IFieldGetDropdownAttrs) {
      self.masterField_SET_LOADING(true)

      const response: IFieldApiDropdownResponse = yield self.environment.masterFieldApi.masterField_getFieldDropdown({
        requestConfig: { ...payload.requestConfig },
      })
      if (response.ok) {
        self.masterField_SET_FIELD_DROPDOWN(response.res.data || [])

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response error
        if (payload?.onError) payload.onError()
      }

      self.masterField_SET_LOADING(false)
    }),
  }))

export const createFieldStoreDefaultModel = () => types.optional(FieldStoreModel, {})
